import axios from "axios";

export const http_icons = axios.create({
  baseURL: process.env.VUE_APP_API_ICONS,
  headers: {
    "Authorization": "Bearer " + process.env.VUE_APP_API_ICONS_TOKEN
  }
});

export function search(query, page = 1) {
  return http_icons.get("/instalacoes/ia-beta-produtos", { params: { query, page } });
}
